import React from "react";

type LoadingStateValueType = {
  loading: boolean;
  setLoading: (loading: boolean) => void;
};

const LoadingStateContext = React.createContext<LoadingStateValueType | null>(
  null
);

export const useLoadingState = (): LoadingStateValueType => {
  const context = React.useContext(LoadingStateContext);

  if (!context) {
    throw new Error("useLoadingState must be used within LoadingStateProvider");
  }

  return context;
};

export const LoadingStateProvider: React.FC = ({ children }) => {
  const [loading, setLoading] = React.useState(false);

  const providerValue = {
    loading,
    setLoading,
  };

  return (
    <LoadingStateContext.Provider value={providerValue}>
      {children}
    </LoadingStateContext.Provider>
  );
};
